import styled from 'styled-components';

const Wrapper = styled.section`
  direction: rtl;

  .dashboard {
    display: grid;
    grid-template-columns: 1fr;
  }

  .dashboard-page {
    width: 90vw;
    margin: 0 auto;
    padding: 2rem 0;
    transition: margin-left 0.3s;
    
  }

  @media (min-width: 992px) {
    .dashboard {
      grid-template-columns: auto 1fr;
    }

    .dashboard-page {
      width: 90%;
    }

    .show-sidebar {
      margin-left: 250px;
    }
  }
`;

export default Wrapper;
